import { USER_ROLE } from "../modules/components/utils/contantHelpers";
import { buildStorageUrl } from "./storageUrl";

export const getStartupPath = (startupId, role) => {
  if (!startupId) {
    return "#";
  }

  const rolePaths = {
    [USER_ROLE.PILOTE]: "pilote/",
    [USER_ROLE.BAILLEUR]: "pilote/",
    [USER_ROLE.CONSULTANT]: "consultant/",
  };

  return `/startup/${rolePaths[role] || ""}${startupId}`;
};

export const getDefaultLogoByRole = (role) => {
  const defaultLogos = {
    [USER_ROLE.BAILLEUR]: "defaults/pilote.png",
    [USER_ROLE.PILOTE]: "defaults/pilote.png",
    [USER_ROLE.STARTUP]: "defaults/startup.png",
    [USER_ROLE.CONSULTANT]: "defaults/consultant.png",
  };

  return defaultLogos[role] || "";
};

export const getLogoUrl = (
  startup,
  defaultLogo = "",
) => {
  const logo =
    startup?.logo ||
    defaultLogo;

  return buildStorageUrl(logo);
};

export const getCouvertureUrl = (
  startup,
  defaultCouverture = "defaults/cover.png",
) => {
  const couverture =
    startup?.couverture ||
    defaultCouverture;

  return buildStorageUrl(couverture);
};